import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { message } from 'antd';
import { readNotification } from '@/apis/notifications';
import { refreshNotificationSummary } from '@/store/modules/notifications';

const useViewedNotification = (id, ready) => {
  const dispatch = useDispatch();
  const { isAuthenticated, userInfo, sessionVersion } = useSelector(state => state.user);
  const read = useRef(null);
  useEffect(() => {
    if (!ready || !isAuthenticated || !/^[1-9]\d*$/.test(id || '') || read.current === id) return;
    let active = true;
    readNotification(id).then(result => {
      if (!active) return;
      if (result?.is_read !== true) throw new Error('已读响应无效');
      read.current = id;
      return dispatch(refreshNotificationSummary());
    }).catch(() => { if (active) message.warning('内容已打开，但通知已读状态未能更新，请在消息页重试'); });
    return () => { active = false; };
  }, [dispatch, id, ready, isAuthenticated, userInfo?.id, sessionVersion]);
};
export default useViewedNotification;
